export var defaultButtonProps = {
    fullWidth: false,
    size: 'medium',
};
